import React from 'react';

// Animated stepper with prev/current/next labels and top navigation controls
const AutoplannerProgress = ({
  steps,
  currentStep,
  onNext,
  onBack,
  canGoNext = true,
  canGoBack = true,
}) => (
  <div className="sticky top-0 z-30 hidden border-b bg-white/95 backdrop-blur md:block">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="py-4">
        {/* Top controls */}
        <div className="mb-3 flex items-center justify-between">

          {/* Stepper */}
          <div className="flex w-full flex-1 flex-col justify-center px-4">
            {/* Top row: circles + connectors (no labels) */}
            <div className="flex items-center justify-center">
              {steps.map((step, index) => {
                const isCompleted = index < currentStep;
                const isActive = index === currentStep;
                return (
                  <React.Fragment key={`top-${index}`}>
                    <div className="flex items-center" title={step.title}>
                      <div
                        className={`flex h-9 w-9 items-center justify-center rounded-full transition-all duration-300 ${isActive
                          ? 'scale-110 bg-blue-600 text-white shadow'
                          : isCompleted
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-200 text-gray-600'
                          }`}
                      >
                        {isCompleted ? (
                          <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <span className="text-sm font-medium">{index + 1}</span>
                        )}
                      </div>
                    </div>

                    {index < steps.length - 1 && (
                      <div className="mx-2 h-0.5 flex-1">
                        {(() => {
                          const distance = Math.abs(index - currentStep);
                          const baseColor = index < currentStep ? 'bg-blue-600' : 'bg-gray-200';
                          const opacityClass = distance <= 1 ? 'opacity-100' : 'opacity-40';
                          return (
                            <div
                              className={`h-full w-full rounded transition-all duration-500 ${baseColor} ${opacityClass}`}
                            />
                          );
                        })()}
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>

            {/* Bottom row: labels aligned under circles */}
            <div className="mt-2 flex items-start justify-center">
              {steps.map((step, index) => {
                const showLabel = Math.abs(index - currentStep) <= 1;
                return (
                  <React.Fragment key={`bottom-${index}`}>
                    <div className="w-9 text-center">
                      <span
                        className={`text-xs font-medium transition-opacity duration-300 ${showLabel ? 'opacity-100' : 'opacity-0'} whitespace-nowrap text-gray-700`}
                        aria-hidden={!showLabel}
                      >
                        {showLabel ? step.title : ''}
                      </span>
                    </div>
                    {index < steps.length - 1 && <div className="mx-2 flex-1" />}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AutoplannerProgress;
